import React from 'react';
import './CustomTooltip.scss';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

const CustomTooltip = props => {
  const {
    event,
    position = 'bottom',
    content,
    children,
    isDisabled = false,
    title,
  } = props;
  const hasAnyTooltipContent = content !== undefined && content !== null;

  // We had to wrap children in span
  // Otherwise the Tippy will not render the children
  const childrenEl = <span>{children}</span>;
  if (!hasAnyTooltipContent || isDisabled) {
    return childrenEl;
  }
  return (
    <Tooltip
      html={content}
      position={position}
      trigger={event}
      arrow={true}
      arrowSize={'small'}
      disabled={isDisabled}
      title={title}
    >
      {childrenEl}
    </Tooltip>
  );
};

CustomTooltip.defaultProps = {
  position: 'bottom',
  event: 'mouseenter',
  isDisabled: false,
  content: null,
  title: '',
};
CustomTooltip.propTypes = {
  content: PropTypes.node,
  isDisabled: PropTypes.bool,
  event: PropTypes.oneOf(['mouseenter', 'click']),
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  title: PropTypes.string,
};
export default CustomTooltip;
